import React, { useCallback, useEffect, useState } from "react";
import { Add, DeleteOutline } from "@material-ui/icons";
import { Button, Chip, IconButton, Paper, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from "@material-ui/core";
import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";
import api from "../../services/api";
import toastError from "../../errors/toastError";

export default function Departments() {
  const [items, setItems] = useState([]);
  const [name, setName] = useState("");
  const [greeting, setGreeting] = useState("");

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/crm/departments/");
      setItems(data.departments || []);
    } catch (error) {
      toastError(error);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const create = async event => {
    event.preventDefault();
    try {
      await api.post("/crm/departments", { name, greeting, active: true });
      setName("");
      setGreeting("");
      await load();
    } catch (error) {
      toastError(error);
    }
  };

  const toggle = async item => {
    try {
      await api.put(`/crm/departments/${item.id}`, { ...item, active: !item.active });
      await load();
    } catch (error) {
      toastError(error);
    }
  };

  const remove = async id => {
    try {
      await api.delete(`/crm/departments/${id}`);
      await load();
    } catch (error) {
      toastError(error);
    }
  };

  return (
    <MainContainer>
      <MainHeader><Title>Departamentos y bots</Title></MainHeader>
      <div style={{ padding: 16, overflowY: "auto", minWidth: 0 }}>
        <Typography color="textSecondary" paragraph>
          {"Organiz\u00e1 la atenci\u00f3n por \u00e1reas y prepar\u00e1 el mensaje de bienvenida para cada flujo. No se activa ning\u00fan bot externo todav\u00eda."}
        </Typography>
        <Paper component="form" onSubmit={create} variant="outlined" style={{ padding: 16, marginBottom: 16, display: "grid", gap: 12 }}>
          <TextField required fullWidth label="Nombre del departamento" value={name} onChange={event => setName(event.target.value)} />
          <TextField fullWidth label="Mensaje de bienvenida / bot" multiline rowsMin={2} value={greeting} onChange={event => setGreeting(event.target.value)} />
          <Button type="submit" startIcon={<Add />} variant="contained" color="primary" style={{ justifySelf: "start" }}>Crear departamento</Button>
        </Paper>
        <Paper variant="outlined" style={{ overflowX: "auto" }}>
          <Table size="small">
            <TableHead><TableRow><TableCell>Departamento</TableCell><TableCell>Mensaje de bienvenida</TableCell><TableCell>Estado</TableCell><TableCell align="right">Acciones</TableCell></TableRow></TableHead>
            <TableBody>
              {items.map(item => (
                <TableRow key={item.id}>
                  <TableCell style={{ overflowWrap: "anywhere" }}>{item.name}</TableCell>
                  <TableCell style={{ minWidth: 220, overflowWrap: "anywhere" }}>{item.greeting || "Sin mensaje configurado"}</TableCell>
                  <TableCell><Chip size="small" color={item.active ? "primary" : "default"} label={item.active ? "Activo" : "Pausado"} onClick={() => toggle(item)} /></TableCell>
                  <TableCell align="right"><IconButton aria-label="Eliminar departamento" onClick={() => remove(item.id)}><DeleteOutline /></IconButton></TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      </div>
    </MainContainer>
  );
}
